<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'予約施設情報：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'予約施設情報：追加' | translate}}</h1>
      </div>
      <div fxLayout="row" fxLayoutGap="8px">
        <button mat-raised-button color="primary" (click)="addReservationFacility()" [disabled]="!reservationFacilityFormGroup.valid || !isValidSplatsQr()">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
    <div fxLayoutAlign="end">
      <button mat-button (click)="onDisplay('basic')">
        <mat-icon>dataset</mat-icon>
        {{'予約説明' | translate}}
      </button>
      <button mat-button (click)="onDisplay('input')">
        <mat-icon>transcribe</mat-icon>
        {{'予約入力' | translate}}
      </button>
      <button mat-button (click)="onDisplay('mail')">
        <mat-icon>mail</mat-icon>
        {{'予約メール' | translate}}
      </button>
      <button mat-button (click)="onDisplay('key')">
        <mat-icon>key</mat-icon>
        {{'SPLATSキー' | translate}}
      </button>
    </div>
  </div>

  <div mat-dialog-content>
    <form class="form" [formGroup]="reservationFacilityFormGroup">
      <!-- 予約説明 -->
      <div *ngIf="display==='basic'" class="icon-text">
        <mat-icon>dataset</mat-icon>
        <span class="pagetitle">{{'予約説明' | translate}}</span>
      </div>
      <div *ngIf="display==='basic'" class="supplement">&nbsp;&nbsp;&nbsp;&nbsp;{{'ユーザーに表示する予約情報を設定します。' | translate}}
      </div>
      <div *ngIf="display==='basic'" class="dialog-body" fxLayout="row" fxLayoutGap="24px">
        <!-- 画面左部 -->
        <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <div fxLayout="row" fxLayoutGap="20px">
            <!-- ID -->
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">ID</mat-label>
              <input [ngModel]="inReservationFacilityId" matInput placeholder="ID" id="reservationFacilityId"
                formControlName="reservationFacilityId" maxlength="6"
                (ngModelChange)="inReservationFacilityId = $event.toUpperCase()">
              <mat-error *ngIf="reservationFacilityIdControl.invalid">{{ getErrorMessageToReservationFacilityId()
                }}</mat-error>
            </mat-form-field>
            <!-- 属性 -->
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'属性' | translate}}</mat-label>
              <mat-select placeholder="{{'属性' | translate}}" id="reservationFacilityAttributeId"
                formControlName="reservationFacilityAttributeId">
                <mat-option [value]=""></mat-option>
                <mat-option *ngFor="let reservationFacilityAttribute of (reservationFacilityAttributes | async)"
                  [value]="reservationFacilityAttribute.attribute_id">
                  {{ reservationFacilityAttribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- 名称 -->
          <mat-form-field>
            <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
            <input matInput placeholder="{{'名称' | translate}} *" id="reservationFacilityNames"
              value="{{ reservationFacility!.reservation_facility_names | multiName:projectLanguages:projectBaseLang }}"
              readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openReservationFacilityNameDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <mat-error *ngIf="reservationFacilityNamesControl.invalid">{{ getErrorMessageToReservationFacilityNames()
              }}</mat-error>
          </mat-form-field>
          <!-- 詳細 -->
          <mat-form-field>
            <mat-label floatLabel="always">{{'詳細' | translate}} *</mat-label>
            <textarea matInput placeholder="{{'詳細' | translate}}" id="reservationFacilityDescs" rows="3"
              value="{{ reservationFacility!.reservation_facility_descs | multiDesc:projectLanguages:projectBaseLang }}"
              readonly></textarea>
            <button matSuffix mat-stroked-button color="primary" (click)="openReservationFacilityDescDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <mat-error *ngIf="reservationFacilityDescsControl.invalid">{{ getErrorMessageToReservationFacilityDescs()
              }}</mat-error>
          </mat-form-field>
          <!-- 表示期間 -->
          <div class="supplement">{{'▼ユーザーサイト上の表示期間を設定します（表示期限がない場合は省略）。' | translate}}</div>
          <div class="inputform30" fxLayout="row" fxLayoutGap="10px">
            <mat-form-field fxFlex="50%">
              <mat-label>{{'表示期間(開始日時)' | translate}}</mat-label>
              <input matInput [ngxMatDatetimePicker]="startDatePicker" placeholder="{{'開催期間(開始日時)' | translate}}"
                formControlName="dispStartDate" readonly>
              <button class="clear-button" mat-button matSuffix aria-label="Clear" (click)="clearDispStartDate()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle matSuffix [for]="$any(startDatePicker)"></mat-datepicker-toggle>
              <ngx-mat-datetime-picker #startDatePicker [showSeconds]=true
                [defaultTime]="[0, 0, 0]"></ngx-mat-datetime-picker>
              <mat-error *ngIf="dispStartDateControl.hasError('before_disp_start_date')">{{
                getErrorMessageToDispStartDate() }}</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="50%">
              <mat-label>{{'表示期間(終了日時)' | translate}}</mat-label>
              <input matInput [ngxMatDatetimePicker]="endDatePicker" placeholder="{{'開催期間(終了日時)' | translate}}"
                formControlName="dispEndDate" readonly>
              <button class="clear-button" mat-button matSuffix aria-label="Clear" (click)="clearDispEndDate()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle matSuffix [for]="$any(endDatePicker)"></mat-datepicker-toggle>
              <ngx-mat-datetime-picker #endDatePicker [showSeconds]=true
                [defaultTime]="[23, 59, 59]"></ngx-mat-datetime-picker>
              <mat-error *ngIf="dispEndDateControl.hasError('before_disp_start_date')">{{ getErrorMessageToDispEndDate()
                }}</mat-error>
            </mat-form-field>
          </div>
          <!-- 予約施設画像ファイル -->
          <div class="reservation-facility-files">
            <div class="reservation-facility-files-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{'予約施設画像ファイル（' | translate}} {{ !!reservationFacility!.reservation_facility_files ?
                reservationFacility!.reservation_facility_files.length:0 }} {{'件）' | translate}}</span>
              <button mat-stroked-button (click)="openSelectFilesDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'ファイル追加' | translate}}</span>
              </button>
            </div>
            <table>
              <thead>
                <tr>
                  <th>{{'画像' | translate}}</th>
                  <th>{{'名称' | translate}}</th>
                  <th style="width: 100px;">{{'言語' | translate}}</th>
                  <th>{{'削除' | translate}}</th>
                </tr>
              </thead>
              <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDrop($event)">
                <tr *ngFor="let reservationFacilityFile of reservationFacilityFiles; let i=index" cdkDrag
                  cdkDragLockAxis="y">
                  <td><img [src]="reservationFacilityFile.download_url" height="40px" width="auto"></td>
                  <td>{{ reservationFacilityFile.file_name }}</td>
                  <td>
                    <mat-select id="lang" [value]="reservationFacilityFile.lang_code"
                      (selectionChange)="changeReservationFacilityFileLang(i, $event)">
                      <ng-container *ngFor="let language of projectLanguages">
                        <mat-option [value]="language.lang_code">
                          {{ currentLang == 'en' ?  (language.lang_name_en ? language.lang_name_en : (language.lang_name | translate)): language.lang_name }}
                        </mat-option>
                      </ng-container>
                    </mat-select>
                  </td>
                  <td>
                    <button mat-stroked-button color="warn" (click)="deleteFiles(i)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 画面右部 -->
        <div class="dialog-right" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <div class="supplement">{{'▼予約施設の位置情報を設定します。' | translate}}</div>
          <!-- 地図 -->
          <google-map *ngIf="center" height="400px" width="100%" step="0.00000001" [center]="center" [zoom]="zoom"
            [options]="options">
            <map-marker #markerElem *ngIf="currentPosition" step="0.00000001" [position]="currentPosition"
              [options]="currentPositionMarkerOption" (mapDragend)="onMerkerDragEnd($event)">
            </map-marker>
          </google-map>
          <input #mapSearchField class="map-search-field" type="text"
            (keydown)="onKeyDownFromSearchPlace($event.keyCode)" />
          <button #mapSearchFieldExecute (click)="searchMap()">{{'移動' | translate}}</button>
          <button #mapSearchFieldClear (click)="clearMapSearchField()">{{'クリア' | translate}}</button>
          <div class="reservation-facility-area" fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'緯度' | translate}}</mat-label>
              <input matInput placeholder="{{'緯度' | translate}}" id="reservationFacilityLat"
                formControlName="reservationFacilityLat" type="number" step="0.00000001" (change)="onBlurMarkerLat()">
              <mat-error *ngIf="reservationFacilityLatControl.invalid">{{ getErrorMessageToHallLat() }}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'経度' | translate}}</mat-label>
              <input matInput placeholder="{{'経度' | translate}}" id="reservationFacilityLng"
                formControlName="reservationFacilityLng" type="number" step="0.00000001" (change)="onBlurMarkerLng()">
              <mat-error *ngIf="reservationFacilityLngControl.invalid">{{ getErrorMessageToHallLng() }}</mat-error>
            </mat-form-field>
          </div>
          <mat-checkbox formControlName="showMarker" color="primary">{{'MAPページに位置を表示する' | translate}}</mat-checkbox>
        </div>
      </div>



      <!-- 予約入力 -->
      <div *ngIf="display==='input'" class="icon-text">
        <mat-icon>transcribe</mat-icon>
        <span class="pagetitle">{{'予約入力' | translate}}</span>
      </div>
      <div *ngIf="display==='input'" class="supplement">&nbsp;&nbsp;&nbsp;&nbsp;{{'ユーザー入力に関する情報を設定します。' | translate}}
      </div>
      <div *ngIf="display==='input'" class="dialog-body" fxLayout="row" fxLayoutGap="24px">
        <!-- 画面左部 -->
        <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <!-- 予約可能期間 -->
          <div class="supplement">{{'▼予約可能期間' | translate}}&nbsp;&nbsp;&nbsp;&nbsp;{{'※予約カレンダー上で日付選択を可能とする期間を設定します。' |
            translate}}</div>
          <div class="inputform10" fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'予約期間（開始）' | translate}}</mat-label>
              <mat-select placeholder="{{'予約期間（開始）' | translate}}" id="reservationStartDate"
                formControlName="reservationStartDate">
                <mat-option *ngFor="let reservationStartDate of reservationPastNumberDays"
                  [value]="reservationStartDate">{{ reservationStartDate | numberDay }}</mat-option>
              </mat-select>
              <mat-error *ngIf="reservationStartDateControl.invalid">{{ getErrorMessageToReservationStartDate()
                }}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'予約期間（終了）' | translate}}</mat-label>
              <mat-select placeholder="{{'予約期間（終了）' | translate}}" id="reservationEndDate"
                formControlName="reservationEndDate">
                <mat-option *ngFor="let reservationEndDate of reservationNumberDays" [value]="reservationEndDate">{{
                  reservationEndDate | numberDay }}</mat-option>
              </mat-select>
              <mat-error>{{ getErrorMessageToReservationEndDate() }}</mat-error>
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutGap="20px">
            <!-- キャンセル期限 -->
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'キャンセル期限' | translate}}</mat-label>
              <mat-select placeholder="{{'キャンセル期限' | translate}}" id="reservationCancel"
                formControlName="reservationCancel">
                <mat-option *ngFor="let reservationCancel of reservationNumberDays" [value]="reservationCancel">{{
                  reservationCancel | numberDay }}</mat-option>
              </mat-select>
              <mat-error *ngIf="reservationCancelControl.invalid">{{ getErrorMessageToReservationCancel() }}</mat-error>
            </mat-form-field>

            <!-- 抽選日 -->
            <mat-form-field fxFlex="50%" *ngIf="reservationMethodControl.value===RESERVATION_METHOD_LOTTERY">
              <mat-label floatLabel="always">{{'抽選日' | translate}}</mat-label>
              <mat-select placeholder="{{'抽選日' | translate}}" id="reservationLotteryDate"
                formControlName="reservationLotteryDate">
                <mat-option *ngFor="let reservationLotteryDate of reservationNumberDays"
                  [value]="reservationLotteryDate">{{ reservationLotteryDate | numberDay }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- 予約日限定 -->
          <div class="supplement">{{'▼予約限定' | translate}}<br>
            &nbsp;&nbsp;&nbsp;{{'※予約可能期間の中で、予約日を限定したい場合に設定します。' | translate}}<br>
            &nbsp;&nbsp;&nbsp;{{'※予約限定（開始＋終了）を指定した場合は、その期間のみ予約が可能となります。' | translate}}<br>
            &nbsp;&nbsp;&nbsp;{{'※予約限定を単日とする場合は予約限定（開始）のみ設定します。' | translate}}
          </div>
          <div class="inputform10" fxLayout="row" fxLayoutGap="10px">
            <mat-form-field fxFlex="50%">
              <mat-label>{{'予約限定（開始）' | translate}}</mat-label>
              <input matInput [matDatepicker]="reservationOpenStartDatePicker" placeholder="{{'予約限定（開始）' | translate}}"
                formControlName="reservationOpenStartDate" readonly>
              <button class="clear-button" mat-button matSuffix aria-label="Clear" (click)="clearReservationOpenStartDate()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle matSuffix [for]="$any(reservationOpenStartDatePicker)"></mat-datepicker-toggle>
              <mat-datepicker #reservationOpenStartDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field fxFlex="50%">
              <mat-label>{{'予約限定（終了）' | translate}}</mat-label>
              <input matInput [matDatepicker]="reservationOpenEndDatePicker" placeholder="{{'予約限定（終了）' | translate}}"
                formControlName="reservationOpenEndDate" readonly>
              <button class="clear-button" mat-button matSuffix aria-label="Clear" (click)="clearReservationOpenEndDate()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle matSuffix [for]="$any(reservationOpenEndDatePicker)"></mat-datepicker-toggle>
              <mat-datepicker #reservationOpenEndDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <!-- 定休日 -->
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-label>{{'定休日' | translate}}</mat-label>
            <mat-checkbox formControlName="sunday" color="primary">{{'日' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="monday" color="primary">{{'月' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="tuesday" color="primary">{{'火' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="wednesday" color="primary">{{'水' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="thursday" color="primary">{{'木' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="friday" color="primary">{{'金' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="saturday" color="primary">{{'土' | translate}}</mat-checkbox>
          </div>
          <!-- 予約可能期間、定休日表示 -->
          <div class="supplement">{{'▼チェックすると、ユーザーに予約可能期間、定休日の情報は表示されません。' | translate}}</div>
          <div class="inputform10" fxLayout="raw" fxLayoutGap="20px">
            <mat-checkbox formControlName="isHideReservationCondition" color="primary">{{'予約条件（予約開始／終了、定休日など）を表示しない' |
              translate}}</mat-checkbox>
          </div>
          <!-- 予約方式 -->
          <div class="supplement">{{'▼予約方式、予約上限枠数を設定します。' | translate}}</div>
          <div class="inputform10" fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'予約方式' | translate}}</mat-label>
              <mat-select placeholder="{{'予約方式' | translate}}" id="reservationMethod"
                formControlName="reservationMethod" (selectionChange)="changeReservationMethod()">
                <mat-option *ngFor="let reservationMethod of reservationMethods" [value]="reservationMethod">{{
                  reservationMethod | methodOfReservation }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutGap="20px">
            <!-- 予約単位 -->
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'予約単位' | translate}}</mat-label>
              <mat-select placeholder="{{'予約単位' | translate}} *" id="reservationUnit" formControlName="reservationUnit">
                <mat-option *ngFor="let reservationUnit of reservationUnits" [value]="reservationUnit">{{
                  reservationUnit | unitOfReservation }}</mat-option>
              </mat-select>
            </mat-form-field>
            <!-- 最大予約数 -->
            <mat-form-field fxFlex="50%" *ngIf="reservationUnitControl.value!==RESERVATION_UNIT_TIME">
              <mat-label floatLabel="always">{{'最大予約数' | translate}}</mat-label>
              <input matInput placeholder="{{'最大予約数' | translate}} *" id="reservationCount"
                formControlName="reservationCount" type="number">
              <mat-error>{{ getErrorMessageToReservationCount() }}</mat-error>
            </mat-form-field>
          </div>
          <!-- 利用日（延泊）表示 -->
          <div
            *ngIf="reservationUnitControl.value!==RESERVATION_UNIT_TIME && reservationMethodControl.value!==RESERVATION_METHOD_LOTTERY"
            class="supplement">{{'▼チェックすると、ユーザーに利用日（延泊）は表示されません。' | translate}}</div>
          <div
            *ngIf="reservationUnitControl.value!==RESERVATION_UNIT_TIME && reservationMethodControl.value!==RESERVATION_METHOD_LOTTERY"
            class="inputform10" fxLayout="raw" fxLayoutGap="20px">
            <mat-checkbox formControlName="isHideReservationEndDate" color="primary">{{'利用日（延泊）を表示しない' | translate}}</mat-checkbox>
          </div>
          <!-- 時間枠 -->
          <div fxLayout="row" *ngIf="reservationUnitControl.value===RESERVATION_UNIT_TIME"
            fxLayoutAlign="space-between end">
            <div class="supplement">{{'※１つ以上の時間枠を設定してください。' | translate}}</div>
            <button mat-stroked-button (click)="appendTime()">
              <mat-icon>add</mat-icon>
              <span>{{'時間枠追加' | translate}}</span>
            </button>
          </div>
          <table *ngIf="reservationUnitControl.value===RESERVATION_UNIT_TIME">
            <thead>
              <tr>
                <th width="60px">{{'開始' | translate}}</th>
                <th width="20px"></th>
                <th width="60px"></th>
                <th width="20px"></th>
                <th width="60px">{{'終了' | translate}}</th>
                <th width="20px"></th>
                <th width="60px"></th>
                <th width="20px"></th>
                <th width="120px">{{'最大予約数' | translate}}</th>
                <th width="20px"></th>
                <th width="70px">{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropSelectItem($event)">
              <tr *ngFor="let reservation_select_time of reservationFacility!.reservation_select_times!; let i = index"
                cdkDrag cdkDragLockAxis="y">
                <td width="60px">
                  <mat-select value="{{ reservation_select_time.items[0] }}">
                    <mat-option *ngFor="let start_hour of hours" value="{{ start_hour }}"
                      (click)="onSelectItemChange(i, 0, start_hour)">{{ start_hour }}</mat-option>
                  </mat-select>
                </td>
                <td width="20px">:</td>
                <td width="60px">
                  <mat-select value="{{ reservation_select_time.items[1] }}">
                    <mat-option *ngFor="let start_minute of minutes" value="{{ start_minute }}"
                      (click)="onSelectItemChange(i, 1, start_minute)">{{ start_minute }}</mat-option>
                  </mat-select>
                </td>
                <td width="20px">　〜　</td>
                <td width="60px">
                  <mat-select value="{{ reservation_select_time.items[2] }}">
                    <mat-option *ngFor="let end_hour of hours" value="{{ end_hour }}"
                      (click)="onSelectItemChange(i, 2, end_hour)">{{ end_hour }}</mat-option>
                  </mat-select>
                </td>
                <td width="20px">:</td>
                <td width="60px">
                  <mat-select value="{{ reservation_select_time.items[3] }}">
                    <mat-option *ngFor="let end_minute of minutes" value="{{ end_minute }}"
                      (click)="onSelectItemChange(i, 3, end_minute)">{{ end_minute }}</mat-option>
                  </mat-select>
                </td>
                <td width="20px"></td>
                <td width="120px">
                  <mat-form-field fxFlexFill floatLabel="always">
                    <input matInput value="{{ reservation_select_time.value }}"
                      (change)="onSelectValueChange($event, i)" type="number" required>
                  </mat-form-field>
                </td>
                <td width="20px"></td>
                <td width="70px" style="overflow: auto;">
                  <button mat-stroked-button color="warn" (click)="deleteClick(i)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <mat-checkbox
            *ngIf="reservationUnitControl.value===RESERVATION_UNIT_TIME && reservationMethodControl.value===RESERVATION_METHOD_FIRST"
            formControlName="isMultiSelect" color="primary">{{'1日あたりの時間帯の複数選択を可能にする' | translate}}</mat-checkbox>
        </div>

        <!-- 画面右部 -->
        <div class="dialog-right" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <!-- 予約設問（基本項目） -->
          <div class="supplement">{{'▼予約時にユーザーに回答してもらう項目を設定します。' | translate}}</div>
          <mat-label class="inputform10">{{'予約設問（基本項目：チェックありで表示）' | translate}}</mat-label>
          <div fxLayout="raw wrap" fxLayoutGap="20px">
            <mat-checkbox formControlName="isVisibledCompanyName" color="primary">{{'会社名' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledDepartment" color="primary">{{'部署' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledJobTitle" color="primary">{{'役職' | translate}}</mat-checkbox>
            <ng-container *ngIf="projectBaseLang === 'ja'">
              <mat-checkbox formControlName="isVisibledSurnameChinese" color="primary">{{'姓（漢字）' | translate}}</mat-checkbox>
              <mat-checkbox formControlName="isVisibledNameChinese" color="primary">{{'名（漢字）' | translate}}</mat-checkbox>
            </ng-container>
            <mat-checkbox formControlName="isVisibledFamilyName" color="primary">{{'姓（カナ）' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledFirstName" color="primary">{{'名（カナ）' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledGender" color="primary">{{'性別' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledBirthday" color="primary">{{'生年月日' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledAddress" color="primary">{{'住所' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledMobilePhoneNumber" color="primary">{{'携帯電話番号' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledUserRequest" color="primary">{{'備考欄' | translate}}</mat-checkbox>
          </div>
          <mat-label>{{'予約設問（基本項目：「備考欄」を別名にしたい場合）' | translate}}</mat-label>
          <mat-form-field>
            <mat-label floatLabel="always">{{'備考欄' | translate}}</mat-label>
            <input matInput placeholder="{{'備考欄' | translate}}" id="reservationUserInputTitles"
              value="{{ reservationFacility!.reservation_user_input_titles | multiUserInputTitle:projectLanguages:projectBaseLang }}"
              readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openReservationUserInputTitleDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>
          <!-- 予約設問（カスタム項目） -->
          <div class="supplement">{{'▼基本項目以外に回答してもらう項目（予約設問で登録済のもの）を設定します。' | translate}}</div>
          <div class="inputform20 floor-list">
            <div class="floor-list-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{'予約設問（カスタム項目：' | translate}} {{ !!reservationFacility && !!reservationFacility.questions ?
                reservationFacility.questions.length:0 }} {{'件' | translate}}）</span>
              <button mat-stroked-button (click)="openSelectQuestionsDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'設問追加' | translate}}</span>
              </button>
            </div>
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>{{'設問名' | translate}}</th>
                  <th>{{'設問タイプ' | translate}}</th>
                  <th>{{'削除' | translate}}</th>
                </tr>
              </thead>
              <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropQuestion($event)">
                <tr *ngFor="let question of reservationFacility?.questions" cdkDrag cdkDragLockAxis="y">
                  <td>{{ question.question_id }}</td>
                  <td>{{ question.question_names | multiName:projectLanguages:projectBaseLang }}</td>
                  <td>{{ question.question_type }}</td>
                  <td>
                    <button mat-stroked-button color="warn" (click)="deleteQuestion(question.question_id!)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>



      <!-- 予約メール -->
      <div *ngIf="display==='mail'" class="icon-text">
        <mat-icon>mail</mat-icon>
        <span class="pagetitle">{{'予約メール' | translate}}</span>
      </div>
      <div *ngIf="display==='mail'" class="supplement">&nbsp;&nbsp;&nbsp;&nbsp;{{'予約関連のメール文面やルールを設定します。' | translate}}
      </div>
      <div *ngIf="display==='mail'" class="dialog-body" fxLayout="row" fxLayoutGap="24px">
        <!-- 画面左部 -->
        <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <!-- ユーザー予約完了時：メール設定 -->
          <div class="supplement">{{'▼ユーザー予約完了時：メール文面の設定' | translate}}</div>
          <mat-form-field>
            <mat-label floatLabel="always">{{'メールタイトル' | translate}}</mat-label>
            <input matInput placeholder="{{'メールタイトル' | translate}} *" id="reservationSendMailTitles"
              value="{{ reservationFacility!.reservation_send_mail_titles | multiSendMailTitle:projectLanguages:projectBaseLang }}"
              readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openReservationSendMailMessageTitleDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <mat-error *ngIf="reservationSendMailTitlesControl.invalid">{{ getErrorMessageToReservationSendMailTitles()
              }}</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label floatLabel="always">{{'メール本文（文頭）*　※メール本文の文頭に配置します。' | translate}}</mat-label>
            <textarea matInput placeholder="{{'メール本文（文頭）*　※メール本文の文頭に配置します。' | translate}}"
              id="reservationSendMailMessages1" rows="3"
              value="{{ reservationFacility!.reservation_send_mail_messages1 | multiSendMailMessage:projectLanguages:projectBaseLang }}"
              readonly></textarea>
            <button matSuffix mat-stroked-button color="primary" (click)="openReservationSendMailMessageHeaderDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <mat-error *ngIf="reservationSendMailMessages1Control.invalid">{{
              getErrorMessageToReservationSendMailMessages1() }}</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label floatLabel="always">{{'メール本文（文中）　※メール本文の文頭、予約情報（予約日時など）の下に配置します（例：留意事項など）。' |
              translate}}</mat-label>
            <textarea matInput placeholder="{{'メール本文（文中）　※メール本文の文頭、予約情報（予約日時など）の下に配置します（例：留意事項など）。' | translate}}"
              id="reservationSendMailMessages2" rows="3"
              value="{{ reservationFacility!.reservation_send_mail_messages2 | multiSendMailMessage:projectLanguages:projectBaseLang }}"
              readonly></textarea>
            <button matSuffix mat-stroked-button color="primary" (click)="openReservationSendMailMessageMiddleDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field>
            <mat-label floatLabel="always">{{'メール本文（末尾）　※メール本文の末尾に配置します（例：問い合わせ先など）。' | translate}}</mat-label>
            <textarea matInput placeholder="{{'メール本文（末尾）　※メール本文の末尾に配置します（例：問い合わせ先など）。' | translate}}"
              id="reservationSendMailMessages3" rows="3"
              value="{{ reservationFacility!.reservation_send_mail_messages3 | multiSendMailMessage:projectLanguages:projectBaseLang }}"
              readonly></textarea>
            <button matSuffix mat-stroked-button color="primary" (click)="openReservationSendMailMessageFooterDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>
          <div class="supplement">{{'▼ユーザー予約完了時：事務局への通知メール文面の設定' | translate}}</div>
          <mat-form-field class="inputform20">
            <mat-label floatLabel="always">{{'メール本文（文頭）　※メール本文の文頭に配置します。' | translate}}</mat-label>
            <textarea matInput placeholder="{{'メール本文（文頭）　※メール本文の文頭に配置します。' | translate}}"
              id="reservationSecretariatMailMessages1" rows="3"
              value="{{ reservationFacility!.reservation_secretariat_mail_messages1 | multiMailMessage:projectLanguages:projectBaseLang }}"
              readonly></textarea>
            <button matSuffix mat-stroked-button color="primary"
              (click)="openReservationSecretariatMailMessageHeaderDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>
          <!-- ユーザー予約完了メールにキャンセル期限表示 -->
          <div class="supplement">{{'▼ユーザー予約完了メール本文表示制御' | translate}}</div>
          <div class="inputform10" fxLayout="raw" fxLayoutGap="20px">
            <mat-checkbox formControlName="isHideReservationCancelDateMessage" color="primary">{{'予約キャンセル期限を表示しない' |
              translate}}</mat-checkbox>
          </div>
          <!-- ユーザー予約完了メールに予約キャンセルリンク表示 -->
          <div class="inputform10" fxLayout="raw" fxLayoutGap="20px">
            <mat-checkbox formControlName="isHideReservationSendMailCancelMessage" color="primary">{{'予約キャンセルリンクを表示しない'
              | translate}}</mat-checkbox>
          </div>
          <!-- ユーザー予約完了メールに展示物情報表示 -->
          <div class="inputform10" fxLayout="raw" fxLayoutGap="20px">
            <mat-checkbox formControlName="isExhibitInfoMessage" color="primary">{{'展示物情報（ID、名称）を表示する' |
              translate}}</mat-checkbox>
          </div><br>
          <!-- ユーザー予約キャンセル時：メール設定 -->
          <div class="supplement">{{'▼ユーザー予約キャンセル時：メール文面の設定' | translate}}</div>
          <mat-form-field>
            <mat-label floatLabel="always">{{'メールタイトル' | translate}}</mat-label>
            <input matInput placeholder="{{'メールタイトル' | translate}} " id="reservationCancelMailTitles"
              value="{{ reservationFacility!.reservation_cancel_mail_titles | multiMailTitle:projectLanguages:projectBaseLang }}"
              readonly>
            <button matSuffix mat-stroked-button color="primary"
              (click)="openReservationCancelMailMessageTitleDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <!-- <mat-error *ngIf="reservationCancelMailTitlesControl.invalid">{{ getErrorMessageToReservationCancelMailTitles() }}</mat-error> -->
          </mat-form-field>
          <mat-form-field>
            <mat-label floatLabel="always">{{'メール本文（文頭）　※メール本文の文頭に配置します。' | translate}}</mat-label>
            <textarea matInput placeholder="{{'メール本文（文頭）　※メール本文の文頭に配置します。' | translate}}"
              id="reservationCancelMailMessages1" rows="3"
              value="{{ reservationFacility!.reservation_cancel_mail_messages1 | multiMailMessage:projectLanguages:projectBaseLang }}"
              readonly></textarea>
            <button matSuffix mat-stroked-button color="primary"
              (click)="openReservationCancelMailMessageHeaderDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <!-- <mat-error *ngIf="reservationCancelMailMessages1Control.invalid">{{ getErrorMessageToReservationCancelMailMessages1() }}</mat-error> -->
          </mat-form-field>
          <mat-form-field>
            <mat-label floatLabel="always">{{'メール本文（文中）　※メール本文の文頭、予約情報（予約日時など）の下に配置します（例：留意事項など）。' |
              translate}}</mat-label>
            <textarea matInput placeholder="{{'メール本文（文中）　※メール本文の文頭、予約情報（予約日時など）の下に配置します（例：留意事項など）。' | translate}}"
              id="reservationCancelMailMessages2" rows="3"
              value="{{ reservationFacility!.reservation_cancel_mail_messages2 | multiMailMessage:projectLanguages:projectBaseLang }}"
              readonly></textarea>
            <button matSuffix mat-stroked-button color="primary"
              (click)="openReservationCancelMailMessageMiddleDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field>
            <mat-label floatLabel="always">{{'メール本文（末尾）　※メール本文の末尾に配置します（例：問い合わせ先など）。' | translate}}</mat-label>
            <textarea matInput placeholder="{{'メール本文（末尾）　※メール本文の末尾に配置します（例：問い合わせ先など）。' | translate}}"
              id="reservationCancelMailMessages3" rows="3"
              value="{{ reservationFacility!.reservation_cancel_mail_messages3 | multiMailMessage:projectLanguages:projectBaseLang }}"
              readonly></textarea>
            <button matSuffix mat-stroked-button color="primary"
              (click)="openReservationCancelMailMessageFooterDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>
          <div class="supplement">{{'▼ユーザー予約キャンセル時：事務局への通知メール文面の設定' | translate}}</div>
          <mat-form-field class="inputform20">
            <mat-label floatLabel="always">{{'メール本文（文頭）　※メール本文の文頭に配置します。' | translate}}</mat-label>
            <textarea matInput placeholder="{{'メール本文（文頭）　※メール本文の文頭に配置します。' | translate}}"
              id="reservationSecretariatCancelMailMessages1" rows="3"
              value="{{ reservationFacility!.reservation_secretariat_cancel_mail_messages1 | multiMailMessage:projectLanguages:projectBaseLang }}"
              readonly></textarea>
            <button matSuffix mat-stroked-button color="primary"
              (click)="openReservationSecretariatCancelMailMessageHeaderDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <!-- 画面右部 -->
        <div class="dialog-right" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <div class="supplement">{{'▼リマインドメール：メール文面の設定' | translate}}</div>
          <mat-form-field>
            <mat-label floatLabel="always">{{'メールタイトル' | translate}}</mat-label>
            <input matInput placeholder="{{'メールタイトル' | translate}}" id="reservationRemindMailTitles"
              value="{{ reservationFacility!.reservation_remind_mail_titles | multiMailTitle:projectLanguages:projectBaseLang }}"
              readonly>
            <button matSuffix mat-stroked-button color="primary"
              (click)="openReservationRemindMailMessageTitleDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <!-- <mat-error *ngIf="reservationRemindMailTitlesControl.invalid">{{ getErrorMessageToReservationRemindMailTitles() }}</mat-error> -->
          </mat-form-field>
          <mat-form-field>
            <mat-label floatLabel="always">{{'メール本文（文頭）　※メール本文の文頭に配置します。' | translate}}</mat-label>
            <textarea matInput placeholder="{{'メール本文（文頭）　※メール本文の文頭に配置します。' | translate}}"
              id="reservationRemindMailMessages1" rows="3"
              value="{{ reservationFacility!.reservation_remind_mail_messages1 | multiMailMessage:projectLanguages:projectBaseLang }}"
              readonly></textarea>
            <button matSuffix mat-stroked-button color="primary"
              (click)="openReservationRemindMailMessageHeaderDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <!-- <mat-error *ngIf="reservationRemindMailMessages1Control.invalid">{{ getErrorMessageToReservationRemindMailMessages1() }}</mat-error> -->
          </mat-form-field>
          <mat-form-field>
            <mat-label floatLabel="always">{{'メール本文（文中）　※メール本文の文頭、予約情報（予約日時など）の下に配置します（例：留意事項など）。' |
              translate}}</mat-label>
            <textarea matInput placeholder="{{'メール本文（文中）　※メール本文の文頭、予約情報（予約日時など）の下に配置します（例：留意事項など）。' | translate}}"
              id="reservationRemindMailMessages2" rows="3"
              value="{{ reservationFacility!.reservation_remind_mail_messages2 | multiMailMessage:projectLanguages:projectBaseLang }}"
              readonly></textarea>
            <button matSuffix mat-stroked-button color="primary"
              (click)="openReservationRemindMailMessageMiddleDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field>
            <mat-label floatLabel="always">{{'メール本文（末尾）　※メール本文の末尾に配置します（例：問い合わせ先など）。' | translate}}</mat-label>
            <textarea matInput placeholder="{{'メール本文（末尾）　※メール本文の末尾に配置します（例：問い合わせ先など）。' | translate}}"
              id="reservationRemindMailMessages3" rows="3"
              value="{{ reservationFacility!.reservation_remind_mail_messages3 | multiMailMessage:projectLanguages:projectBaseLang }}"
              readonly></textarea>
            <button matSuffix mat-stroked-button color="primary"
              (click)="openReservationRemindMailMessageFooterDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>
          <div class="supplement">{{'▼リマインドメール：予約開始日のX日前にユーザーにリマインドメールを送信します(最大2回まで)。' | translate}}</div>
          <div class="supplement inputform20">{{'※送信時間は一律PM0:00となります。' | translate}}</div>
          <mat-error *ngIf="onedayControl.invalid" style="font-size: 13px;">{{ getErrorMessageToOneDay() }}</mat-error>
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-checkbox formControlName="oneday" color="primary" (change)="setRemindCount()">{{'1日前' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="twoday" color="primary" (change)="setRemindCount()">{{'2日前' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="threeday" color="primary" (change)="setRemindCount()">{{'3日前' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="fourday" color="primary" (change)="setRemindCount()">{{'4日前' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="fiveday" color="primary" (change)="setRemindCount()">{{'5日前' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="sixday" color="primary" (change)="setRemindCount()">{{'6日前' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="sevenday" color="primary" (change)="setRemindCount()">{{'7日前' | translate}}</mat-checkbox>
          </div>

          <div class="supplement">{{'▼事務局へのメール通知設定' | translate}}</div>
          <div class="inputform30" fxLayout="row" fxLayoutAlign="space-between end">
            <div class="supplement">{{'※ユーザーへのメール送信時に事務局へのメール通知が必要な場合は、メールアドレスを設定してください。' | translate}}</div>
            <button mat-stroked-button (click)="appendMail()" style="width: 230px;">
              <mat-icon>add</mat-icon>
              <span>{{'メールアドレス追加' | translate}}</span>
            </button>
          </div>
          <table
            *ngIf="reservationFacility!.secretariat_mail_addresses && reservationFacility!.secretariat_mail_addresses.length > 0">
            <thead>
              <tr>
                <th>{{'メールアドレス' | translate}}</th>
                <th width="70px">{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropSelectItem($event)">
              <tr
                *ngFor="let secretariat_mail_address of reservationFacility!.secretariat_mail_addresses!; let i = index"
                cdkDrag cdkDragLockAxis="y">
                <td>
                  <mat-form-field fxFlexFill floatLabel="always">
                    <input matInput value="{{ secretariat_mail_address }}" (change)="onSelectMailChange(i, $event)">
                  </mat-form-field>
                </td>
                <td width="70px" style="overflow: auto;">
                  <button mat-stroked-button color="warn" (click)="deleteMail(i)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- ユーザー予約保留時：メール設定 -->
          <ng-container *ngIf="reservationMethodControl.value !== RESERVATION_METHOD_FIRST">
            <div class="supplement">{{'▼ユーザー予約保留時：メール文面の設定' | translate}}</div>
            <mat-form-field>
              <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
              <input matInput placeholder="{{'メールタイトル' | translate}} *" id="reservationOnHoldMailTitles"
                value="{{ reservationFacility!.reservation_on_hold_mail_titles | multiMailTitle:projectLanguages:projectBaseLang }}"
                readonly>
              <button matSuffix mat-stroked-button color="primary"
                (click)="openReservationOnHoldMailMessageTitleDialog()">
                <mat-icon>edit</mat-icon>
              </button>
              <mat-error *ngIf="reservationOnHoldMailTitlesControl.invalid">{{
                getErrorMessageToReservationOnHoldMailTitles() }}</mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label floatLabel="always">{{'メール本文（文頭）*　※メール本文の文頭に配置します。' | translate}}</mat-label>
              <textarea matInput placeholder="{{'メール本文（文頭）*　※メール本文の文頭に配置します。' | translate}}"
                id="reservationOnHoldMailMessages1" rows="3"
                value="{{ reservationFacility!.reservation_on_hold_mail_messages1 | multiMailMessage:projectLanguages:projectBaseLang }}"
                readonly></textarea>
              <button matSuffix mat-stroked-button color="primary"
                (click)="openReservationOnHoldMailMessageHeaderDialog()">
                <mat-icon>edit</mat-icon>
              </button>
              <mat-error *ngIf="reservationOnHoldMailMessages1Control.invalid">{{
                getErrorMessageToReservationOnHoldMailMessages1() }}</mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label floatLabel="always">{{'メール本文（文中）　※メール本文の文頭、予約情報（予約日時など）の下に配置します（例：留意事項など）。' | translate}}</mat-label>
              <textarea matInput placeholder="{{'メール本文（文中）　※メール本文の文頭、予約情報（予約日時など）の下に配置します（例：留意事項など）。' | translate}}"
                id="reservationOnHoldMailMessages2" rows="3"
                value="{{ reservationFacility!.reservation_on_hold_mail_messages2 | multiMailMessage:projectLanguages:projectBaseLang }}"
                readonly></textarea>
              <button matSuffix mat-stroked-button color="primary"
                (click)="openReservationOnHoldMailMessageMiddleDialog()">
                <mat-icon>edit</mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field>
              <mat-label floatLabel="always">{{'メール本文（末尾）　※メール本文の末尾に配置します（例：問い合わせ先など）。' | translate}}</mat-label>
              <textarea matInput placeholder="{{'メール本文（末尾）　※メール本文の末尾に配置します（例：問い合わせ先など）。' | translate}}"
                id="reservationOnHoldMailMessages3" rows="3"
                value="{{ reservationFacility!.reservation_on_hold_mail_messages3 | multiMailMessage:projectLanguages:projectBaseLang }}"
                readonly></textarea>
              <button matSuffix mat-stroked-button color="primary"
                (click)="openReservationOnHoldMailMessageFooterDialog()">
                <mat-icon>edit</mat-icon>
              </button>
            </mat-form-field>

            <!-- ユーザー予約落選時：メール設定 -->
            <div class="supplement">{{'▼ユーザー予約落選時：メール文面の設定' | translate}}</div>
            <mat-form-field>
              <mat-label floatLabel="always">{{'メールタイトル' | translate}}</mat-label>
              <input matInput placeholder="{{'メールタイトル' | translate}} *" id="reservationLostMailTitles"
                value="{{ reservationFacility!.reservation_lost_mail_titles | multiMailTitle:projectLanguages:projectBaseLang }}"
                readonly>
              <button matSuffix mat-stroked-button color="primary"
                (click)="openReservationLostMailMessageTitleDialog()">
                <mat-icon>edit</mat-icon>
              </button>
              <mat-error *ngIf="reservationLostMailTitlesControl.invalid">{{
                getErrorMessageToReservationLostMailTitles() }}</mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label floatLabel="always">{{'メール本文（文頭）*　※メール本文の文頭に配置します。' | translate}}</mat-label>
              <textarea matInput placeholder="{{'メール本文（文頭）*　※メール本文の文頭に配置します。' | translate}}"
                id="reservationLostMailMessages1" rows="3"
                value="{{ reservationFacility!.reservation_lost_mail_messages1 | multiMailMessage:projectLanguages:projectBaseLang }}"
                readonly></textarea>
              <button matSuffix mat-stroked-button color="primary"
                (click)="openReservationLostMailMessageHeaderDialog()">
                <mat-icon>edit</mat-icon>
              </button>
              <mat-error *ngIf="reservationLostMailMessages1Control.invalid">{{
                getErrorMessageToReservationLostMailMessages1() }}</mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label floatLabel="always">{{'メール本文（文中）　※メール本文の文頭、予約情報（予約日時など）の下に配置します（例：留意事項など）。' | translate}}</mat-label>
              <textarea matInput placeholder="{{'メール本文（文中）　※メール本文の文頭、予約情報（予約日時など）の下に配置します（例：留意事項など）。' | translate}}"
                id="reservationLostMailMessages2" rows="3"
                value="{{ reservationFacility!.reservation_lost_mail_messages2 | multiMailMessage:projectLanguages:projectBaseLang }}"
                readonly></textarea>
              <button matSuffix mat-stroked-button color="primary"
                (click)="openReservationLostMailMessageMiddleDialog()">
                <mat-icon>edit</mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field>
              <mat-label floatLabel="always">{{'メール本文（末尾）　※メール本文の末尾に配置します（例：問い合わせ先など）。' | translate}}</mat-label>
              <textarea matInput placeholder="{{'メール本文（末尾）　※メール本文の末尾に配置します（例：問い合わせ先など）。' | translate}}"
                id="reservationLostMailMessages3" rows="3"
                value="{{ reservationFacility!.reservation_lost_mail_messages3 | multiMailMessage:projectLanguages:projectBaseLang }}"
                readonly></textarea>
              <button matSuffix mat-stroked-button color="primary"
                (click)="openReservationLostMailMessageFooterDialog()">
                <mat-icon>edit</mat-icon>
              </button>
            </mat-form-field>
          </ng-container>
        </div>
      </div>

      <!-- キー -->
      <div *ngIf="display==='key'" class="icon-text">
        <mat-icon>key</mat-icon>
        <span class="pagetitle">{{'SPLATSキー' | translate}}</span>
      </div>
      <div *ngIf="display==='key'" class="supplement">&nbsp;&nbsp;&nbsp;&nbsp;{{'施設を施錠するSPLATSのキーを設定します。' | translate}}</div>
      <div *ngIf="display==='key'" class="dialog-body" fxLayout="row" fxLayoutGap="24px">
        <!-- 画面左部 -->
        <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
            <!-- 環境 -->
            <div fxLayout="row" fxLayoutGap="20px">
              <mat-form-field fxFlex="50%">
                <mat-label floatLabel="always">{{'環境' | translate}}</mat-label>
                <mat-select placeholder="{{'環境' | translate}}" id="splatsApiType" formControlName="splatsApiType" (selectionChange)="onApiTypeChange()">
                  <mat-option *ngFor="let apiType of splatsApiTypes" [value]="apiType.key">{{ apiType.value }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="20px">
              <!-- キーボックス -->
              <mat-form-field fxFlex="50%">
                <mat-label floatLabel="always">{{'キーボックス' | translate}}</mat-label>
                <mat-select placeholder="{{'キーボックス' | translate}}" id="splatsKeyDeviceId" formControlName="splatsKeyDeviceId" (selectionChange)="onKeyDeviceChange($event)">
                    <mat-option value=""></mat-option>
                    <ng-container *ngFor="let keyDevice of keyDevices">
                      <mat-option *ngIf="splatsApiTypeControl.value === keyDevice.api_type" [value]="keyDevice.id">{{ keyDevice.name }}</mat-option>
                    </ng-container>
                </mat-select>
              </mat-form-field>
              <!-- キー -->
              <mat-form-field fxFlex="50%">
                <mat-label floatLabel="always">{{'キー' | translate}}</mat-label>
                <mat-select placeholder="{{'キー' | translate}}" id="splatsUnitNo" formControlName="splatsUnitNo">
                  <mat-option *ngFor="let unit of units" [value]="unit.no"><span [ngClass]="{'used-unit-no' : unit.is_used}">{{ unit.name }}</span></mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="20px">
            <!-- 借受猶予時間 -->
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'借受猶予時間' | translate}}</mat-label>
              <mat-select placeholder="{{'借受猶予時間' | translate}}" id="splatsBorrowGraceMinutes" formControlName="splatsBorrowGraceMinutes">
                  <ng-container *ngFor="let graceMinutes of splatsGraceMinutes">
                    <mat-option [value]="graceMinutes.key">{{ graceMinutes.value }}</mat-option>
                  </ng-container>
              </mat-select>
            </mat-form-field>
            <!-- 返却猶予時間 -->
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'返却猶予時間' | translate}}</mat-label>
              <mat-select placeholder="{{'返却猶予時間' | translate}}" id="splatsReturnGraceMinutes" formControlName="splatsReturnGraceMinutes">
                <ng-container *ngFor="let graceMinutes of splatsGraceMinutes">
                  <mat-option [value]="graceMinutes.key">{{ graceMinutes.value }}</mat-option>
                </ng-container>
            </mat-select>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <!-- QRコードに出力する予約設問(基本項目) -->
              <div class="supplement">{{'▼キーボックス開扉用QRコードと共に出力する項目を設定します。(最大5つ)' | translate}}</div>
              <mat-label class="inputform10">{{'予約設問（基本項目：チェックありで出力）' | translate}}</mat-label>
              <div fxLayout="raw wrap" fxLayoutGap="20px">
                <mat-checkbox formControlName="isVisibledSplatsQrCompanyName" color="primary">{{'会社名' | translate}}</mat-checkbox>
                <mat-checkbox formControlName="isVisibledSplatsQrDepartment" color="primary">{{'部署' | translate}}</mat-checkbox>
                <mat-checkbox formControlName="isVisibledSplatsQrJobTitle" color="primary">{{'役職' | translate}}</mat-checkbox>
                <ng-container *ngIf="projectBaseLang === 'ja'">
                  <mat-checkbox formControlName="isVisibledSplatsQrSurnameNameChinese" color="primary">{{'姓名（漢字）' | translate}}</mat-checkbox>
                </ng-container>
                <mat-checkbox formControlName="isVisibledSplatsQrFamilyFirstName" color="primary">{{'姓名（カナ）' | translate}}</mat-checkbox>
                <mat-checkbox formControlName="isVisibledSplatsQrGender" color="primary">{{'性別' | translate}}</mat-checkbox>
                <mat-checkbox formControlName="isVisibledSplatsQrBirthday" color="primary">{{'生年月日' | translate}}</mat-checkbox>
                <mat-checkbox formControlName="isVisibledSplatsQrAddress" color="primary">{{'住所' | translate}}</mat-checkbox>
                <mat-checkbox formControlName="isVisibledSplatsQrMobilePhoneNumber" color="primary">{{'携帯電話番号' | translate}}</mat-checkbox>
                <mat-checkbox formControlName="isVisibledSplatsQrUserRequest" color="primary">{{'備考欄' | translate}}</mat-checkbox>
              </div>
            </div>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>
